<!-- src/App.vue -->
<template>
  <Blog />
</template>

<script setup>
import Blog from "../components/Blog";
import { useHead } from '@vueuse/head'

useHead({
  title: 'Grapefroot | Blogs',
  meta: [
    {
      name: 'description',
      content: 'Meta description',
    },
  ],
})

</script>
